import compact from "lodash/compact";
import { CvExportsButton } from "PFApp/components/cv_exports_button";
import { LegacyLazyLocalExportTrigger } from "PFApp/legacy_cv_export_flow";
import { useSearchStoreContext } from "PFApp/search/search_context";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { FeatureFlag } from "PFTypes";
import { useTranslation } from "react-i18next";

import { HeaderToolbox } from "../../components/header_toolbox";
import css from "../search_page.module.scss";
import { matchesTab, profilesTab } from "../tabs_constants";
import {
  getLegacyCvExportMatchesCollection,
  getLegacyCvExportProfilesCollection
} from "./legacy_cv_export_profiles_collection";

export const SearchPageExportButtons = () => {
  const { t } = useTranslation();
  const {
    search: { tab, matches, profiles, searchActivity }
  } = useSearchStoreContext();
  const isEnabled = useIsFeatureEnabled();
  const isLegacyCvExport = isEnabled(FeatureFlag.CVExportLegacyFlow);

  const exportButtonProps = {
    text: t("exportText"),
    icon: undefined,
    kind: "primary"
  } as const;

  if (isLegacyCvExport) {
    return (
      <HeaderToolbox
        className={css.headerToolbox}
        items={compact([
          tab === matchesTab && (
            <LegacyLazyLocalExportTrigger
              buttonKind="primary"
              quantity={matches?.length || 0}
              getProfilesCollection={getLegacyCvExportMatchesCollection(matches || [])}
            />
          ),
          tab === profilesTab && (
            <LegacyLazyLocalExportTrigger
              buttonKind="primary"
              quantity={profiles?.length || 0}
              getProfilesCollection={getLegacyCvExportProfilesCollection(profiles || [])}
            />
          )
        ])}
      />
    );
  }

  return (
    <HeaderToolbox
      className={css.headerToolbox}
      items={compact([
        tab === matchesTab && (
          <CvExportsButton
            profileIds={(matches || []).map(({ profile }) => profile.id)}
            activityId={searchActivity?.id}
            {...exportButtonProps}
          />
        ),
        tab === profilesTab && (
          <CvExportsButton profileIds={(profiles || []).map(({ id }) => id)} {...exportButtonProps} />
        )
      ])}
    />
  );
};
